﻿import { ILoginHashData } from "./ILoginHashData";

export class LoginHashDataManager {

    public encode(data: ILoginHashData): string {
        return "#" + $.param(data);
    }

    public decode(hash: string): ILoginHashData {

        if (hash.length != 0 && hash.charAt(0) == '#') {
            hash = hash.substr(1);
        }

        return $.deparam(hash);
    }
}